import axios, { AxiosResponse } from "axios";
import environment from "../config";
import axiosUtil from "../utils/helpers/axiosUtil";
import { MAX_SERVER_REQUESTS_ERROR, MEMBER_NOT_FOUND } from "./OtpVerifyRegisterWithBankAccount";


export enum deeplink {
    validAndUser = "validAndUser",
    validAndNotUser = "validAndNotUser",
    notValid = "notValid",
  }

export async function CheckDeeplinkValid(
    requestID: string
) {
    if (requestID) {
        try {
            const body = {
                requestID: requestID
            };
            const path = environment.BASE_URL + "MemberLogin/CheckDeeplinkValid";
            const res: AxiosResponse<any> = await axios.post(path, body);                                               
            if (axiosUtil.isSuccess(res)) return deeplink.validAndUser;
            // handle max server case
            if (res?.data?.errorCode === 34) return deeplink.validAndNotUser;
            if (res?.data?.errorCode === 36) return deeplink.notValid;
            if (res?.data?.errorCode === 666) return deeplink.notValid;
            if (res?.data?.errorCode === -999) return deeplink.notValid;

            return deeplink.notValid;
        } catch (err) {
            console.log(err);
        }
    }
    return false;
}
